<template lang="pug">
.mb-10
  AppOnOffToggle(v-model="includeRemovedMembers")
    | Include removed members
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ReportIncludeRemovedMembersToggle',
  computed: {
    ...mapState(['organization']),
    includeRemovedMembers: {
      get() {
        return this.$store.getters.includeRemovedMembers;
      },
      set(newValue) {
        this.$store.dispatch('updateSearch', { include_removed_members: !!newValue });
      },
    },
  },
};
</script>
